// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AdminPanel.css */
.admin-navbar {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: #3f3e3e;
  border-radius: 2px;
  box-shadow: 0 2px 4px rgba(56, 1, 1, 0.1);
  width: 50px;
  height: 620px;
  padding: 20px;
  position: fixed;
  top: 70px;
  left: 0;
  z-index: 1000;
  transition: width 0.3s ease;
}

.admin-nav {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5px;
}

.admin-nav-Link {
  text-decoration: none;
  color: #ffffff;
  margin: 15px 0;
  font-size: 40px; /* Increase font size for larger icons */
  transition: color 0.3s ease; /* Add transition for color change */
}

.admin-nav-Link:hover {
  color: #ffd700; /* Change color on hover */
}

.logout-button {
  background-color: #ee5050;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  cursor: pointer;
  margin-top: 20px;
  transition: background-color 0.3s ease; /* Add transition for background color change */
}

.logout-button:hover {
  background-color: #b30000; /* Change background color on hover */
}

/* Media query for screens up to 768px */
@media screen and (max-width: 768px) {
  .admin-navbar {
    flex-direction: row; /* Change to row direction */
    justify-content: center; /* Center items horizontally */
    align-items: center; /* Center items vertically */
    width: 100%; /* Full width */
    height: auto; /* Adjust height based on content */
    padding: 10px;
    top: 60px; /* Adjust based on your design */
    background-color: #333;
    position: static; /* Change position to static for mobile view */
  }

  .admin-nav {
    display: flex;
    flex-direction: row; /* Align links horizontally */
    margin: 0; /* Remove top margin */
  }

  .admin-nav-Link {
    font-size: 18px; /* Adjust font size for smaller screens */
    margin: 0 15px; /* Increase spacing between links */
  }

  .logout-button {
    margin-top: 0; /* Remove top margin for logout button */
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Admin/adminNavbar/adminnavbar.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,aAAa;EACb,aAAa;EACb,eAAe;EACf,SAAS;EACT,OAAO;EACP,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,eAAe,EAAE,wCAAwC;EACzD,2BAA2B,EAAE,oCAAoC;AACnE;;AAEA;EACE,cAAc,EAAE,0BAA0B;AAC5C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC,EAAE,+CAA+C;AACzF;;AAEA;EACE,yBAAyB,EAAE,qCAAqC;AAClE;;AAEA,wCAAwC;AACxC;EACE;IACE,mBAAmB,EAAE,4BAA4B;IACjD,uBAAuB,EAAE,8BAA8B;IACvD,mBAAmB,EAAE,4BAA4B;IACjD,WAAW,EAAE,eAAe;IAC5B,YAAY,EAAE,mCAAmC;IACjD,aAAa;IACb,SAAS,EAAE,gCAAgC;IAC3C,sBAAsB;IACtB,gBAAgB,EAAE,8CAA8C;EAClE;;EAEA;IACE,aAAa;IACb,mBAAmB,EAAE,6BAA6B;IAClD,SAAS,EAAE,sBAAsB;EACnC;;EAEA;IACE,eAAe,EAAE,yCAAyC;IAC1D,cAAc,EAAE,mCAAmC;EACrD;;EAEA;IACE,aAAa,EAAE,wCAAwC;IACvD,eAAe;EACjB;AACF","sourcesContent":["/* AdminPanel.css */\n.admin-navbar {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  background-color: #3f3e3e;\n  border-radius: 2px;\n  box-shadow: 0 2px 4px rgba(56, 1, 1, 0.1);\n  width: 50px;\n  height: 620px;\n  padding: 20px;\n  position: fixed;\n  top: 70px;\n  left: 0;\n  z-index: 1000;\n  transition: width 0.3s ease;\n}\n\n.admin-nav {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 5px;\n}\n\n.admin-nav-Link {\n  text-decoration: none;\n  color: #ffffff;\n  margin: 15px 0;\n  font-size: 40px; /* Increase font size for larger icons */\n  transition: color 0.3s ease; /* Add transition for color change */\n}\n\n.admin-nav-Link:hover {\n  color: #ffd700; /* Change color on hover */\n}\n\n.logout-button {\n  background-color: #ee5050;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  padding: 10px 20px;\n  cursor: pointer;\n  margin-top: 20px;\n  transition: background-color 0.3s ease; /* Add transition for background color change */\n}\n\n.logout-button:hover {\n  background-color: #b30000; /* Change background color on hover */\n}\n\n/* Media query for screens up to 768px */\n@media screen and (max-width: 768px) {\n  .admin-navbar {\n    flex-direction: row; /* Change to row direction */\n    justify-content: center; /* Center items horizontally */\n    align-items: center; /* Center items vertically */\n    width: 100%; /* Full width */\n    height: auto; /* Adjust height based on content */\n    padding: 10px;\n    top: 60px; /* Adjust based on your design */\n    background-color: #333;\n    position: static; /* Change position to static for mobile view */\n  }\n\n  .admin-nav {\n    display: flex;\n    flex-direction: row; /* Align links horizontally */\n    margin: 0; /* Remove top margin */\n  }\n\n  .admin-nav-Link {\n    font-size: 18px; /* Adjust font size for smaller screens */\n    margin: 0 15px; /* Increase spacing between links */\n  }\n\n  .logout-button {\n    margin-top: 0; /* Remove top margin for logout button */\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
